import React from "react";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { RectBtn } from "../../components/General";
import { useDispatch, useSelector } from "react-redux";
import { deleteRoom } from "../../features/slices/roomSlice";
import { selectDevice, selectRoom, selectSensor } from "../../features/store";
import { deleteSensor } from "../../features/slices/sensorSlice";
import { deleteDevice } from "../../features/slices/deviceSlice";
import { useSnackbar } from "notistack";
import { deleteBuilding as deleteBuildingApi } from "../../apis/Building.Api";
import { deleteBuilding } from "../../features/slices/buildingSlice";
const DeleteBuilding = ({ selectedConfig, setSelectedConfig, openDelete, setOpenDelete }) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const rooms = useSelector(selectRoom);
    const sensors = useSelector(selectSensor);
    const devices = useSelector(selectDevice);
    async function confirmDeleteBld() {
        let r = await deleteBuildingApi({
            building_id: selectedConfig.buildingId,
        });

        if (r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "success" });
            dispatch(deleteBuilding({ buildingId: selectedConfig.buildingId }));
        } else {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }
        let roomsToDelete = [];
        for (let rid in rooms) {
            if (rooms[rid].buildingId === selectedConfig.buildingId) {
                roomsToDelete.push(rid);
                dispatch(deleteRoom({ roomId: rid }));
            }
        }

        for (let sid of Object.keys(sensors)) {
            if (roomsToDelete.includes(sensors[sid].roomId)) {
                dispatch(deleteSensor({ sensorId: sid }));
            }
        }
        for (let did of Object.keys(devices)) {
            if (roomsToDelete.includes(devices[did].roomId)) {
                dispatch(deleteDevice({ deviceId: did }));
            }
        }
        setOpenDelete(false);
        setSelectedConfig({});
    }
    return (
        <PopUp width={50} height={50} switchOn={openDelete}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Confirmation</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenDelete(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="confirmation-wrapper">
                        <h4> Delete Building? </h4>
                        <p className="description">
                            By confirming, the building
                            <strong>{" " + selectedConfig.buildingName + " "}</strong>
                            and <strong> ALL </strong> its rooms, sensors, and devices will be deleted. This action
                            cannot be restored.
                        </p>
                        <div className="btn-wrapper">
                            <RectBtn onClick={confirmDeleteBld} warning={true}>
                                <p>Delete</p>
                            </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default DeleteBuilding;
